import { createApi } from '@reduxjs/toolkit/query/react';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { AddWebhookRequestType, WebhookInterface } from '@interface/webhook/webhook.interface';
import { apiQueryAuth } from '@util/api/api-query-auth';

export const webhookApi = createApi({
  reducerPath: 'webhook-api',
  tagTypes: [TagTypesEnum.Webhook],
  baseQuery: apiQueryAuth('', true),
  endpoints: (build) => ({
    loadWebhook: build.query<ResponseDataInterface<WebhookInterface[]>, void>({
      query: () => '/webhooks',
      providesTags: [TagTypesEnum.Webhook],
    }),
    addWebhook: build.mutation<ResponseDataInterface<WebhookInterface>, Omit<AddWebhookRequestType, 'id'>>({
      query: (credentials) => ({
        url: '/webhooks',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.Webhook],
    }),
    updateWebhook: build.mutation<ResponseDataInterface<WebhookInterface>, Partial<AddWebhookRequestType>>({
      query: (credentials) => ({
        url: `/webhooks/${credentials.id}`,
        method: 'PATCH',
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.Webhook],
    }),
    triggerEvent: build.mutation<ResponseDataInterface<any>, any>({
      query: (body) => ({
        url: '/webhooks/trigger',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TagTypesEnum.Webhook],
    }),
    deleteWebhook: build.mutation<WebhookInterface, string>({
      query: (id) => ({
        url: `/webhooks/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TagTypesEnum.Webhook],
    }),
  }),
});
